module.exports = __webpack_public_path__ + "static/img/Jye-Gray.8376af8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jye-Gray.jpg
// module id = H3jW
// module chunks = 0